import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask w-full h-full"
}
const _hoisted_2 = { class: "modal-body mtop-10" }
const _hoisted_3 = { class: "row w-full" }
const _hoisted_4 = { class: "col-0-8 colend mright-04" }
const _hoisted_5 = { class: "main-m" }
const _hoisted_6 = { class: "row w-full mtop-10" }
const _hoisted_7 = { class: "col-0-8 colend mright-04" }
const _hoisted_8 = { class: "main-m" }
const _hoisted_9 = { class: "row w-full mtop-10" }
const _hoisted_10 = { class: "col-0-8 colend mright-04" }
const _hoisted_11 = { class: "main-m" }
const _hoisted_12 = {
  key: 0,
  class: "row w-full mtop-10"
}
const _hoisted_13 = { class: "col-0-8 colend mright-04" }
const _hoisted_14 = { class: "main-m" }
const _hoisted_15 = {
  key: 1,
  class: "row w-full mtop-10"
}
const _hoisted_16 = { class: "col-0-8 colend mright-04" }
const _hoisted_17 = { class: "main-m" }
const _hoisted_18 = {
  key: 2,
  class: "row w-full mtop-10"
}
const _hoisted_19 = { class: "col-0-8 colend mright-04" }
const _hoisted_20 = { class: "main-m font-m" }

import { ref, watch } from "vue";
import { onClickOutside } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { AddOrUpdateFinancialGroupRequest, FinancialGroupLightResponse } from '@/apiGenerate/medserver';
import InputText from 'primevue/inputtext';
import ToggleSwitch from 'primevue/toggleswitch';


export default /*@__PURE__*/_defineComponent({
  __name: 'esFinancialGroupForm',
  props: {
    isOpen: { type: Boolean },
    header: {},
    financialGroupLightResponse: {},
    isOwner: { type: Boolean, default: false },
    confirmMethod: {}
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { t } = useI18n();
const target = ref(null);

const addOrUpdateFinancialGroupRequest = ref<AddOrUpdateFinancialGroupRequest>({
  id: undefined,
  code: undefined,
  title: undefined,
  personalInfo: undefined,  
  active: true,
  bic: undefined,
  iban: undefined
});

onClickOutside(target, ()=>emit('modal-close'));

const confirmFormModal = async () => {
  try {
    await props.confirmMethod(addOrUpdateFinancialGroupRequest.value);
  } catch {
    throw t('error.DEFAULT');
  }
}

const closeFormModal = () => {
    emit('modal-close');
}

watch(
    () => props.isOpen,
  () => {
    if (props.isOpen && props.financialGroupLightResponse) {
      addOrUpdateFinancialGroupRequest.value = {
        id: props.financialGroupLightResponse.id,
        code: props.financialGroupLightResponse.code,
        title: props.financialGroupLightResponse.title,
        personalInfo: props.financialGroupLightResponse.personalInfo,        
        active: props.financialGroupLightResponse.active,
        iban: undefined,
        bic: undefined
      }
    } else {
      addOrUpdateFinancialGroupRequest.value = {
        id: undefined,
        code: undefined,
        title: undefined,
        personalInfo:undefined,
        active: true,
        iban: undefined,
        bic: undefined
      }
    }
  }
);


return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-container-day-model",
          ref_key: "target",
          ref: target
        }, [
          _createVNode(_component_es_modal_header, { header: _ctx.header }, null, 8, ["header"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('settings.label.accounting.financialGroup.form.code')), 1)
              ]),
              _createVNode(_unref(InputText), {
                type: "text",
                size: "small",
                modelValue: addOrUpdateFinancialGroupRequest.value.code,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addOrUpdateFinancialGroupRequest.value.code) = $event)),
                class: "w-full",
                disabled: !addOrUpdateFinancialGroupRequest.value.active
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('settings.label.accounting.financialGroup.form.title')), 1)
              ]),
              _createVNode(_unref(InputText), {
                type: "text",
                size: "small",
                modelValue: addOrUpdateFinancialGroupRequest.value.title,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((addOrUpdateFinancialGroupRequest.value.title) = $event)),
                class: "w-full",
                disabled: !addOrUpdateFinancialGroupRequest.value.active
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('settings.label.accounting.financialGroup.form.personalInfo')), 1)
              ]),
              _createVNode(_unref(InputText), {
                modelValue: addOrUpdateFinancialGroupRequest.value.personalInfo,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((addOrUpdateFinancialGroupRequest.value.personalInfo) = $event)),
                class: "w-full",
                rows: "2",
                autoResize: "",
                disabled: !addOrUpdateFinancialGroupRequest.value.active
              }, null, 8, ["modelValue", "disabled"])
            ]),
            (!addOrUpdateFinancialGroupRequest.value.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_unref(t)('settings.label.accounting.financialGroup.form.bic')), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                    ])
                  ]),
                  _createVNode(_unref(InputText), {
                    modelValue: addOrUpdateFinancialGroupRequest.value.bic,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((addOrUpdateFinancialGroupRequest.value.bic) = $event)),
                    class: "w-full",
                    rows: "2",
                    autoResize: "",
                    disabled: !addOrUpdateFinancialGroupRequest.value.active
                  }, null, 8, ["modelValue", "disabled"])
                ]))
              : _createCommentVNode("", true),
            (!addOrUpdateFinancialGroupRequest.value.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, [
                      _createTextVNode(_toDisplayString(_unref(t)('settings.label.accounting.financialGroup.form.iban')), 1),
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                    ])
                  ]),
                  _createVNode(_unref(InputText), {
                    modelValue: addOrUpdateFinancialGroupRequest.value.iban,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addOrUpdateFinancialGroupRequest.value.iban) = $event)),
                    class: "w-full",
                    rows: "2",
                    autoResize: "",
                    disabled: !addOrUpdateFinancialGroupRequest.value.active
                  }, null, 8, ["modelValue", "disabled"])
                ]))
              : _createCommentVNode("", true),
            (addOrUpdateFinancialGroupRequest.value.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)('settings.label.accounting.financialGroup.financialChannel.data.active')), 1)
                  ]),
                  _createVNode(_unref(ToggleSwitch), {
                    disabled: !_ctx.isOwner,
                    modelValue: addOrUpdateFinancialGroupRequest.value.active,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((addOrUpdateFinancialGroupRequest.value.active) = $event))
                  }, null, 8, ["disabled", "modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_es_modal_footer, {
            onModalCancel: closeFormModal,
            confirmModalMethod: () => confirmFormModal(),
            "confirm-disabled": !addOrUpdateFinancialGroupRequest.value.id && (!addOrUpdateFinancialGroupRequest.value.bic || !addOrUpdateFinancialGroupRequest.value.iban)
          }, null, 8, ["confirmModalMethod", "confirm-disabled"])
        ], 512)
      ]))
    : _createCommentVNode("", true)
}
}

})